module.exports = __webpack_public_path__ + "img/shoyu_logo_small.3875980e.png";